import React from 'react'
import RenewMotorLayout from '../../renewalMotorPolicy/renewMotorLayout';
import MobileUploadCarPhotos from '../../newMotorPolicy/uploads/mobileUploadPages/mobileUploadCarPhotos';
import useChangePlanFlow from '../../../../hooks/useChangePlanFlow';
import useRenewalFlow from '../../../../hooks/useRenewalFlow';
import useAdjustSumInsuredFlow from '../../../../hooks/useAdjustSumInsured';
import SelectNewPlanLayout from '../selectNewPlan/selectNewPlanLayout';
import AdjustSumInsuredMotorLayout from '../../adjustSumInsuredFlow/adjustSumInsuredMotorLayout';

const MobileUploadCarPhotoStepperLayout = (passedFrom) => {
    const { handleNextSubstep: handleNextChangePlan, handlePrevSubstep: handlePrevChangePlan } = useChangePlanFlow();
    const { handleNextSubstep: handleNextRenewal, handlePrevSubstep: handlePrevRenewal } = useRenewalFlow();
    const { handleNextSubstep: handleNextAdjustSumInsured, handlePrevSubstep: handlePrevAdjustSumInsured } = useAdjustSumInsuredFlow();
    
    const continueChangePlanHandler = () => {
        handleNextChangePlan()
    }
    
    const continueRenewalHandler = () => {
        handleNextRenewal()
    }
    
    const continueAdjustSumInsuredHandler = () => {
        handleNextAdjustSumInsured()
    }
    
    return (
        <div>
            {passedFrom.passedFrom.passedFrom == "MotorChangeActivePlan" && (
                <SelectNewPlanLayout backClickHandler={handlePrevChangePlan} show_summary={true} btn_onClick={continueChangePlanHandler}>
                    <div className="mt-10">
                        <MobileUploadCarPhotos />
                    </div>
                </SelectNewPlanLayout>
            )}
            {passedFrom.passedFrom.passedFrom == "MotorAdjustSumInsured" && (
                <AdjustSumInsuredMotorLayout backClickHandler={handlePrevAdjustSumInsured} show_summary={true} btn_onClick={continueAdjustSumInsuredHandler}>
                    <div className="mt-10">
                        <MobileUploadCarPhotos />
                    </div>
                </AdjustSumInsuredMotorLayout>
            )}
            {passedFrom.passedFrom.passedFrom == "MotorRenewal" && (
                <RenewMotorLayout backClickHandler={handlePrevRenewal} show_summary={true} btn_onClick={continueRenewalHandler}>
                    <div className="mt-10">
                        <MobileUploadCarPhotos />
                    </div>
                </RenewMotorLayout>
            )}
        </div>
    )
}

export default MobileUploadCarPhotoStepperLayout